module.exports = __webpack_public_path__ + "img/cpe_icons_price.05533c4b.svg";